import React from 'react';
import styled, { css } from 'react-emotion';

import BaseListItem from '@material-ui/core/ListItem';
import BaseListItemText from '@material-ui/core/ListItemText';
import BaseListItemAvatar from '@material-ui/core/ListItemAvatar';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const scrollbarStyle = {
  height: 'inherit',
};

export const Container = styled.div`
  height: 80%;
  max-width: 980px;
  padding-right: ${theme.spacing.xxGiant};
`;

export const TopBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacing.medium} 0px;

  &.loader {
    justify-content: center;
    margin-top: ${theme.spacing.xLarge};
  }
`;

export const NavigationInlineStyle = { maxWidth: '200px' };

export const Provider = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
  }
`;

export const ProviderTitle = styled.span`
  align-items: center;
  color: ${colors.designSystem.purple70};
  display: flex;
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.spacing.medium};

  svg {
    margin-left: 5px;
  }
`;

export const AssignmentTitle = styled.p`
  color: ${colors.blackAlpha(0.87)};
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.spacing.large};
  letter-spacing: 0.15px;
  line-height: ${theme.font.lineHeight.large};
`;

export const DropdownWrapper = styled.div`
  width: 200px;
`;

export const SubmissionCount = styled.p`
  color: ${colors.black};
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.large};
  line-height: ${theme.font.lineHeight.copy};

  span {
    font-weight: ${theme.font.weight.regular};
  }
`;

export const SubmissionGroupTitle = styled.p`
  color: ${colors.blackAlpha(0.6)};
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.small};
  letter-spacing: 0.4px;
  line-height: 16px;
`;

export const SubmissionListItem = styled(({ isHeader, isGroup, ...props }) => (
  <BaseListItem {...props} />
))`
  align-items: center;
  display: flex;
  height: 64px;
  margin-top: 0;
  padding: ${theme.spacing.small} 0;
  ${(props) => props.isGroup && 'padding-left: 12px;'};

  &:hover {
    background-color: ${(props) =>
      props.isHeader ? '' : colors.designSystem.background.grey.hover};
    ${(props) => !props.isHeader && 'cursor: pointer;'};
  }
`;

export const SubmissionListHeaderText = styled(({ dateHeader, ...props }) => (
  <BaseListItemText
    {...props}
    classes={{ primary: 'primary', secondary: 'secondary' }}
  />
))`
  flex: none;
  width: ${(props) => (props.dateHeader ? '24%' : '33%')};
  padding-left: 12px;
  .primary {
    color: ${colors.black};
    font-family: ${theme.font.family.workSans};
    font-weight: ${theme.font.weight.semiBold};
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
  }
`;

export const SubmissionListItemText = styled((props) => (
  <BaseListItemText
    {...props}
    classes={{ primary: 'primary', secondary: 'secondary' }}
  />
))`
  flex: none;
  padding-left: 12px;
  .primary {
    color: ${colors.black};
    font-family: ${theme.font.family.workSans};
    font-weight: normal;
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
  }
`;

export const FullName = styled(({ isGroup, ...props }) => (
  <SubmissionListItemText {...props} />
))`
  width: ${(props) => (props.isGroup ? '25%' : '26%')};
`;

export const GroupName = styled((props) => (
  <SubmissionListItemText {...props} />
))`
  width: 32%;
  margin-left: 12px;
`;

export const SubmissionDate = styled(({ isGroup, ...props }) => (
  <SubmissionListItemText {...props} />
))`
  width: ${(props) => (props.isGroup ? '26%' : '25%')};
`;

export const Grade = styled((props) => <SubmissionListItemText {...props} />)`
  width: 6%;
`;

export const SubmissionHyperLink = styled((props) => (
  <SubmissionListItemText {...props} />
))`
  width: 19%;
  .primary {
    color: ${colors.blackAlpha(0.6)};
  }
  .primary > span {
    align-items: center;
    display: flex;
  }
  .primary > span > svg {
    padding-left: 5px;
  }
`;

export const VisuallyHidden = css`
  :not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const AvatarWrapper = styled.div`
  width: 7%;
  display: flex;
  justify-content: center;
`;

export const SubmissionListItemAvatar = styled(BaseListItemAvatar)`
  margin: 0;
  width: 40px;
  height: 40px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${theme.spacing.large};
`;

export const DropdownStyle = { width: '200px' };
export const DropdownItemStyle = {
  height: 'auto',
  padding: '0',
};
